/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Fix: Popular search linklerinde gerçek URL varsa oraya git, arama yapma
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-popular-searches-link]');
    if (link) {
      var href = link.getAttribute('href');
      if (href && href !== '' && !href.includes('/search')) {
        event.stopPropagation();
        event.preventDefault();
        window.location.href = href;
      }
    }
  }, true);







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ============================================================
   Strengthener template — custom elements
   Kaynak: theme-export-ohora-com-duplicate-isb-03-06-260
   ============================================================ */

// --- OhoraColumns (ohr-section-columns.liquid) ---
class OhoraColumns extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  initSwiper() {
    if (this._initialized) return;

    const sectionId = this.dataset.sectionId;
    const swiperEl = this.querySelector(`.swiper-${sectionId}`);
    if (!swiperEl) return;

    const doInit = () => {
      if (swiperEl.offsetWidth === 0) {
        requestAnimationFrame(doInit);
        return;
      }

      this._initialized = true;

      new Swiper(swiperEl, {
        pagination: {
          el: swiperEl.querySelector('.ohora-columns-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: swiperEl.querySelector('.ohora-column-next-btn'),
          prevEl: swiperEl.querySelector('.ohora-column-prev-btn'),
        },
        breakpoints: {
          0: { slidesPerView: 1.1, spaceBetween: 22 },
          768: { slidesPerView: 2.1, spaceBetween: 22 },
          1024: { slidesPerView: 2.8, spaceBetween: 35 }
        }
      });
    };

    requestAnimationFrame(doInit);
  }

  connectedCallback() {
    this.initSwiper();
  }
}

if (!customElements.get('ohora-columns')) {
  customElements.define('ohora-columns', OhoraColumns);
}

document.addEventListener('shopify:section:load', (event) => {
  const el = event.target;
  el.querySelectorAll('ohora-columns').forEach(component => {
    component.initSwiper();
  });
});

// --- OhoraSimpleVideo (ohora-video.liquid) ---
if (!customElements.get('ohr-simple-video')) {
  class OhoraSimpleVideo extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this._scrollHandler = null;
      this._raf = null;
      this._latestY = 0;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.initVideoControls();
      this.initAutoplayState();
      this.initScrollShrink();
    }

    initScrollShrink() {
      const wrap = this.querySelector(".simplevideo-wrapper");
      if (!wrap) return;

      const update = () => {
        this._raf = null;
        const isMobile = window.innerWidth <= 768;
        const vh = window.innerHeight;
        const rect = wrap.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;
        const trigger = isMobile ? vh * 0.6 : vh * 0.55;
        const range   = isMobile ? vh * 0.45 : vh * 0.35;
        let p = (trigger - centerY) / range;
        p = Math.max(0, Math.min(1, p));
        const scaleMin  = isMobile ? 0.93 : 0.94;
        const radiusMax = 15;
        const scale  = 1 - (1 - scaleMin) * p;
        const radius = radiusMax * p;
        wrap.style.transform = `scale(${scale})`;
        wrap.style.clipPath  = `inset(0% round ${radius}px)`;
      };

      const onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(update);
      };

      this._scrollHandler = onScroll;
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    }

    disconnectedCallback() {
      if (this._scrollHandler) {
        window.removeEventListener("scroll", this._scrollHandler);
        window.removeEventListener("resize", this._scrollHandler);
      }
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    initAutoplayState() {
      const wrappers = this.querySelectorAll(".simplevideo-wrapper");
      wrappers.forEach((wrap) => {
        const video = this.getVisibleVideoFrom(wrap);
        if (!video) return;
        const btn = wrap.querySelector(".simplevideo-play-btn");
        if (!btn) return;
        const playIcon = btn.querySelector(".play-icon");
        const pauseIcon = btn.querySelector(".pause-icon");
        video.addEventListener("canplay", () => {
          setTimeout(() => {
            if (!video.paused) {
              playIcon.style.display = "none";
              pauseIcon.style.display = "block";
            }
          }, 50);
        });
        video.addEventListener("play", () => {
          playIcon.style.display = "none";
          pauseIcon.style.display = "block";
        });
        video.addEventListener("pause", () => {
          playIcon.style.display = "block";
          pauseIcon.style.display = "none";
        });
      });
    }

    getVisibleVideoFrom(wrap) {
      const videos = [...wrap.querySelectorAll("video")];
      if (!videos.length) return null;
      const visible = videos.find(v => v.offsetParent !== null);
      return visible || videos[0];
    }

    initVideoControls() {
      const wrappers = this.querySelectorAll(".simplevideo-wrapper");
      wrappers.forEach((wrap) => {
        const btn = wrap.querySelector(".simplevideo-play-btn");
        if (!btn) return;
        const playIcon = btn.querySelector(".play-icon");
        const pauseIcon = btn.querySelector(".pause-icon");
        const toggleVideo = () => {
          const video = this.getVisibleVideoFrom(wrap);
          if (!video) return;
          if (video.paused) {
            video.play();
            playIcon.style.display = "none";
            pauseIcon.style.display = "block";
          } else {
            video.pause();
            playIcon.style.display = "block";
            pauseIcon.style.display = "none";
          }
        };
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          toggleVideo();
        });
        wrap.addEventListener("click", (e) => {
          if (e.target.closest(".simplevideo-play-btn")) return;
          toggleVideo();
        });
      });
    }
  }

  customElements.define("ohr-simple-video", OhoraSimpleVideo);
}

// --- SwatchButtonProducts (swatch-button-products.liquid) ---
class SwatchButtonProducts extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.slides = [...this.querySelectorAll(".sbp-slide")];
    this.swatches = [...this.querySelectorAll(".sbp-swatch-btn")];
    this.swiperContainer = this.querySelector(".sbp-swiper");
    this.initSwiper();
    this.bindSwatches();
    this.activateIndex(0);
  }

  initSwiper() {
    // Swiper bu sayfada yuklu olmayabilir; yoksa section cokmesin diye guard'la.
    // Bu durumda CSS izgara fallback'i devreye girer (bkz. .sbp-no-swiper).
    if (typeof Swiper === "undefined") {
      this.classList.add("sbp-no-swiper");
      return;
    }

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1.6,
      spaceBetween: 12,
      allowTouchMove: true,
      breakpoints: {
        769: { slidesPerView: 4, spaceBetween: 32, allowTouchMove: true }
      },
      on: { slideChange: () => this.handleSlideChange() }
    });
  }

  activateIndex(index) {
    this.slides.forEach((s) => s.classList.remove("is-active"));
    this.swatches.forEach((s) => s.classList.remove("is-active"));
    this.slides[index]?.classList.add("is-active");
    this.swatches[index]?.classList.add("is-active");
  }

  bindSwatches() {
    if (!this.swiper) return;

    this.swatches.forEach((btn) => {
      const index = Number(btn.dataset.index);
      btn.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 769) {
          this.swiper.slideTo(index);
          this.activateIndex(index);
        }
      });
      btn.addEventListener("click", () => {
        if (window.innerWidth < 769) {
          this.swiper.slideTo(index);
          this.activateIndex(index);
        }
      });
    });
  }

  handleSlideChange() {
    if (window.innerWidth >= 769) return;
    const translate = this.swiper.translate * -1;
    let bestIndex = 0;
    let minDistance = Infinity;
    this.slides.forEach((slide, idx) => {
      const dist = Math.abs(slide.offsetLeft - translate);
      if (dist < minDistance) {
        minDistance = dist;
        bestIndex = idx;
      }
    });
    this.activateIndex(bestIndex);
  }
}

customElements.define("swatch-button-products", SwatchButtonProducts);

// --- SyrupFormula (ohora-formula.liquid) ---
class SyrupFormula extends HTMLElement {
  constructor() {
    super();
    this.handleSwatchClick = this.handleSwatchClick.bind(this);
  }

  connectedCallback() {
    this.mainImageEl = this.querySelector('[data-role="main-image"]');
    this.swatchEls = Array.from(this.querySelectorAll('[data-role="syrup-swatch"]'));
    if (!this.mainImageEl || !this.swatchEls.length) return;

    this.swatchEls.forEach((btn) => {
      btn.addEventListener('click', this.handleSwatchClick);
    });

    const defaultGroup = this.dataset.defaultGroup || 'water';
    const groupSwatches = this.swatchEls.filter((btn) => btn.dataset.group === defaultGroup);
    const initialSwatch = groupSwatches[0] || this.swatchEls[0];
    this.setActiveSwatch(initialSwatch);
  }

  disconnectedCallback() {
    this.swatchEls.forEach((btn) => {
      btn.removeEventListener('click', this.handleSwatchClick);
    });
  }

  handleSwatchClick(event) {
    this.setActiveSwatch(event.currentTarget);
  }

  setActiveSwatch(btn) {
    if (!btn) return;
    this.swatchEls.forEach((el) => {
      el.classList.toggle('is-active', el === btn);
    });
    const imgSrc = btn.dataset.mainImage;
    const imgAlt = btn.dataset.mainAlt || '';
    if (imgSrc) this.mainImageEl.src = imgSrc;
    this.mainImageEl.alt = imgAlt;
    this.dataset.activeGroup = btn.dataset.group;
  }
}

if (!customElements.get('syrup-formula')) {
  customElements.define('syrup-formula', SyrupFormula);
}

// --- FtsSwitcher (ohora-text-switcher.liquid) ---
class FtsSwitcher extends HTMLElement {
  connectedCallback() {
    this.textItems = [...this.querySelectorAll('.fts-text-item')];
    this.bullets = [...this.querySelectorAll('.fts-bullet')];

    this.imageSwiper = new Swiper(this.querySelector('.fts-image-swiper'), {
      slidesPerView: 1,
      speed: 700,
      pagination: {
        el: this.querySelector('.fts-image-pagination'),
        clickable: true
      },
      on: {
        slideChange: (sw) => { this.activate(sw.activeIndex); }
      }
    });

    this.bullets.forEach(btn => {
      btn.addEventListener('mouseenter', () => {
        const i = Number(btn.dataset.index);
        this.imageSwiper.slideTo(i);
        this.activate(i);
      });
    });

    new Swiper(this.querySelector('.fts-mobile-swiper'), {
      slidesPerView: 1,
      speed: 600,
      pagination: {
        el: this.querySelector('.fts-mobile .swiper-pagination'),
        clickable: true
      }
    });
  }

  activate(index) {
    this.textItems.forEach((el, i) => el.classList.toggle('is-active', i === index));
    this.bullets.forEach((el, i) => el.classList.toggle('is-active', i === index));
  }
}

customElements.define('fts-switcher', FtsSwitcher);

// --- OhoraDuoSlider (ohora-image-with-product.liquid) ---
class OhoraDuoSlider extends HTMLElement {
  connectedCallback() {
    setTimeout(() => this.init(), 80);
  }

  init() {
    const id = this.dataset.sectionId;
    const leftEl = document.querySelector(`.duo-left-swiper-${id}`);
    const rightEl = document.querySelector(`.duo-right-swiper-${id}`);
    if (!leftEl || !rightEl) return;

    const leftSwiper = new Swiper(`.duo-left-swiper-${id}`, {
      loop: false,
      pagination: { el: `.duo-left-pagination-${id}`, clickable: true }
    });

    const rightSwiper = new Swiper(`.duo-right-swiper-${id}`, {
      loop: false,
      navigation: { nextEl: `.next-${id}`, prevEl: `.prev-${id}` },
      pagination: { el: `.duo-right-pagination-mobile-${id}`, clickable: true }
    });

    leftSwiper.controller.control = rightSwiper;
    rightSwiper.controller.control = leftSwiper;
  }
}

customElements.define("ohora-duo-slider", OhoraDuoSlider);


// ohora-feature-slides.liquid
class OhoraFeatureSplit extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.textEl = this.querySelector('.feature-text-swiper');
    this.imageEl = this.querySelector('.feature-image-swiper');
    this.countCurrent = this.querySelector('.count-current');

    if (!this.textEl || !this.imageEl) return;

    this.initSwipers();
  }

  initSwipers() {
    this.textSwiper = new Swiper(this.textEl, {
      slidesPerView: 1,
      speed: 600,
      allowTouchMove: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      pagination: {
        el: this.querySelector('.feature-text-pagination'),
        clickable: true
      },
      on: {
        init: sw => this.updateActive(sw.activeIndex),
        slideChange: sw => this.updateActive(sw.activeIndex)
      }
    });

    this.imageSwiper = new Swiper(this.imageEl, {
      slidesPerView: 1,
      speed: 600,
      allowTouchMove: true,
      pagination: {
        el: this.querySelector('.feature-image-pagination'),
        clickable: true
      }
    });

    this.textSwiper.controller.control = this.imageSwiper;
    this.imageSwiper.controller.control = this.textSwiper;
  }

  updateActive(index) {
    const slides = this.querySelectorAll('.feature-slide');
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    if (this.countCurrent) {
      this.countCurrent.textContent = index + 1;
    }
  }
}

customElements.define('ohora-feature-split', OhoraFeatureSplit);


// tab-image-switcher.liquid
class TabImageSwitcher extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('.tis-data');
    if (!dataEl) return;

    this.images = JSON.parse(dataEl.textContent).images;
    this.pcImg = this.querySelector('.pc-img');
    this.mobileImg = this.querySelector('.mobile-img');
    this.tabs = this.querySelectorAll('.tis-tab');
    this.activeColor = this.dataset.activeColor;

    this.initEvents();
    this.applyInitialActiveStyle();
  }

  initEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.updateImage(index));
    });
  }

  applyInitialActiveStyle() {
    this.tabs.forEach(tab => {
      if (tab.classList.contains('is-active')) {
        tab.style.backgroundColor = this.activeColor;
      }
    });
  }

  updateImage(index) {
    const item = this.images[index];
    if (this.pcImg) this.pcImg.src = item.pc;
    if (this.mobileImg) this.mobileImg.src = item.mobile;

    this.tabs.forEach(tab => {
      tab.classList.remove('is-active');
      tab.style.backgroundColor = '#c8c8c8';
    });

    this.tabs[index].classList.add('is-active');
    this.tabs[index].style.backgroundColor = this.activeColor;
  }
}

customElements.define('tab-image-switcher', TabImageSwitcher);


// ─── ohora-image-with-text.liquid ───────────────────────────────────────────

function safeInitSwiper(getEl, initCallback, retry = 0) {
  const el = typeof getEl === 'function' ? getEl() : getEl;
  if (!el) return;
  if (el.offsetWidth > 0 && el.offsetHeight > 0) {
    initCallback(el);
    return;
  }
  if (retry < 20) {
    requestAnimationFrame(() => safeInitSwiper(getEl, initCallback, retry + 1));
  }
}

class IWTDuo extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    safeInitSwiper(
      () => this.querySelector('.iwt-left-swiper'),
      () => this.initSwipers()
    );
  }

  initSwipers() {
    const leftEl = this.querySelector('.iwt-left-swiper');
    const rightEl = this.querySelector('.iwt-right-swiper');
    if (!leftEl || !rightEl) return;

    const isMobile = window.innerWidth <= 768;

    const leftSwiper = new Swiper(leftEl, {
      loop: false,
      speed: 600,
      pagination: {
        el: this.querySelector('.iwt-pagination-left'),
        clickable: true
      }
    });

    const rightSwiper = new Swiper(rightEl, {
      loop: false,
      speed: 500,
      autoHeight: true,
      direction: 'horizontal',
      effect: isMobile ? 'slide' : 'fade',
      fadeEffect: isMobile ? undefined : { crossFade: true },
      pagination: {
        el: this.querySelector('.iwt-pagination-bottom'),
        clickable: true
      }
    });

    leftSwiper.controller.control = rightSwiper;
    rightSwiper.controller.control = leftSwiper;
  }
}

customElements.define('iwt-duo', IWTDuo);


// ─── ohora-vertical-slider-center.liquid ────────────────────────────────────

class OhoraVerticalSlider extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.buttons = this.querySelectorAll('.ohora-vertical-slider__btn');
    this.swiperEl = this.querySelector('.ohora-vertical-slider__swiper');

    if (!this.swiperEl || !this.buttons.length) return;

    this.initSwiper();
    this.bindEvents();
  }

  initSwiper() {
    this.isMobile = window.innerWidth < 769;

    this.swiper = new Swiper(this.swiperEl, {
      direction: 'vertical',
      slidesPerView: 1,
      speed: 350,
      allowTouchMove: false,
      watchSlidesProgress: true
    });

    this.swiper.slideTo(0, 0);
  }

  bindEvents() {
    this.buttons.forEach((btn) => {
      const index = Number(btn.dataset.index);

      if (this.isMobile) {
        btn.addEventListener('click', () => { this.activate(index); });
      } else {
        btn.addEventListener('mouseenter', () => {
          requestAnimationFrame(() => { this.activate(index); });
        });
      }
    });
  }

  activate(index) {
    this.buttons.forEach(btn => btn.classList.remove('is-active'));
    this.buttons[index]?.classList.add('is-active');
    this.swiper.slideTo(index);
  }
}

customElements.define('ohora-vertical-slider', OhoraVerticalSlider);


// ─── ohora-ba-dropdown.liquid ────────────────────────────────────────────────

class OhoraBADropdown extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.initAccordion();
    this.initBeforeAfter();
  }

  initAccordion() {
    this.items = this.querySelectorAll('.bad-item');

    this.items.forEach(item => {
      const trigger = item.querySelector('.bad-trigger');
      const content = item.querySelector('.bad-content');
      if (!trigger || !content) return;

      trigger.addEventListener('click', () => {
        this.items.forEach(other => {
          if (other !== item) {
            other.classList.remove('is-active');
            const c = other.querySelector('.bad-content');
            if (c) c.style.maxHeight = null;
          }
        });

        const isOpen = item.classList.contains('is-active');
        item.classList.toggle('is-active', !isOpen);
        content.style.maxHeight = isOpen ? null : content.scrollHeight + 'px';
      });
    });
  }

  initBeforeAfter() {
    this.ba = this.querySelector('[data-ba]');
    if (!this.ba) return;

    this.handle = this.ba.querySelector('.bad-handle');
    if (!this.handle) return;

    this.dragging = false;

    const move = (clientX) => {
      const rect = this.ba.getBoundingClientRect();
      let pos = ((clientX - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(100, pos));
      this.ba.style.setProperty('--pos', `${pos}%`);
    };

    const startDrag = () => { this.dragging = true; };
    const endDrag = () => { this.dragging = false; };

    this.handle.addEventListener('mousedown', startDrag);
    this.handle.addEventListener('touchstart', startDrag, { passive: true });

    this.addEventListener('mousemove', e => {
      if (!this.dragging) return;
      move(e.clientX);
    });

    this.addEventListener('touchmove', e => {
      if (!this.dragging || !e.touches[0]) return;
      move(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);
  }
}

customElements.define('ohora-ba-dropdown', OhoraBADropdown);
